export function getRandomBytes(numBytes) {
    return crypto.getRandomValues(new Uint8Array(numBytes));
}
//# sourceMappingURL=csprng.js.map